import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

interface StatCardProps {
  label: string;
  value: number | string;
  color?: string;
  onClick?: () => void;
  tint?: string;
}

export default function StatCard({ label, value, color = '#CB6015', onClick, tint }: StatCardProps) {
  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: '12px',
        cursor: onClick ? 'pointer' : 'default',
        backgroundColor: tint || '#FFFFFF',
        '&:hover': onClick ? { boxShadow: '0 4px 12px rgba(0,0,0,0.15)' } : {},
        transition: 'box-shadow 0.2s',
      }}
      onClick={onClick}
    >
      <Typography variant="h4" sx={{ fontWeight: 600, color }}>
        {typeof value === 'number' ? value.toLocaleString() : value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Paper>
  );
}
